// @generated by protobuf-ts 2.9.4 with parameter long_type_string,generate_dependencies
// @generated from protobuf file "list_of_voices.proto" (package "speaker.beta2", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// *
// "accent": "standard german",
// "origin": "germany",
// "age": "25",
// "emotion": "cheerful",
// "style": "advertisement",
// "preview_prompt":
// {
//  // examples with German text are removed since codespell would
//  // complain and codespell:ignore has no effect
//   ["en-GB", "This is the voice of Annie."],
//   ["en-US", "This is the voice of Annie."],
//   ["fr-FR", "Ceci est la voix de Annie."],
//   ["es-419", "Esta es la voz de Annie.]",
//  // examples with special (Spanisch/Italian) characters omitted
//  // as they confuse the proto compiler
// },
// "free_text": {
//   ["en-GB": "Annie is a warm and approachable voice designed for users looking for an engaging and cheerful experience. Her tone is perfect for storytelling, customer service, or educational content."],
//   ["de-DE": "Annie hat eine warme und ansprechende Stimme, geeignet fur Anwender die eine.."]
//  }

/**
 * @generated from protobuf message speaker.beta2.ListOfVoices
 */
export interface ListOfVoices {
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfVoices.VoicesPerFlavor flavors = 1;
   */
  flavors: ListOfVoices_VoicesPerFlavor[];
}
/**
 * @generated from protobuf message speaker.beta2.ListOfVoices.MultilingualText
 */
export interface ListOfVoices_MultilingualText {
  /**
   * @generated from protobuf field: string language = 1;
   */
  language: string;
  /**
   * @generated from protobuf field: string text = 2;
   */
  text: string;
}
/**
 * @generated from protobuf message speaker.beta2.ListOfVoices.Voice
 */
export interface ListOfVoices_Voice {
  /**
   * @generated from protobuf field: string name = 1;
   */
  name: string;
  /**
   * @generated from protobuf field: string gender = 2;
   */
  gender: string;
  /**
   * @generated from protobuf field: string native_language = 3;
   */
  nativeLanguage: string;
  /**
   * @generated from protobuf field: string accent = 4;
   */
  accent: string;
  /**
   * @generated from protobuf field: string origin = 5;
   */
  origin: string;
  /**
   * @generated from protobuf field: string age = 6;
   */
  age: string;
  /**
   * @generated from protobuf field: string emotion = 7;
   */
  emotion: string;
  /**
   * @generated from protobuf field: string style = 8;
   */
  style: string;
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfVoices.MultilingualText preview_prompt = 9;
   */
  previewPrompt: ListOfVoices_MultilingualText[];
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfVoices.MultilingualText free_text = 10;
   */
  freeText: ListOfVoices_MultilingualText[];
}
/**
 * @generated from protobuf message speaker.beta2.ListOfVoices.VoicesPerFlavor
 */
export interface ListOfVoices_VoicesPerFlavor {
  /**
   * @generated from protobuf field: string name = 1;
   */
  name: string;
  /**
   * @generated from protobuf field: string description = 2;
   */
  description: string;
  /**
   * @generated from protobuf field: repeated speaker.beta2.ListOfVoices.Voice voices = 3;
   */
  voices: ListOfVoices_Voice[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ListOfVoices$Type extends MessageType<ListOfVoices> {
  constructor() {
    super("speaker.beta2.ListOfVoices", [
      {
        no: 1,
        name: "flavors",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfVoices_VoicesPerFlavor,
      },
    ]);
  }
  create(value?: PartialMessage<ListOfVoices>): ListOfVoices {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.flavors = [];
    if (value !== undefined)
      reflectionMergePartial<ListOfVoices>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfVoices
  ): ListOfVoices {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* repeated speaker.beta2.ListOfVoices.VoicesPerFlavor flavors */ 1:
          message.flavors.push(
            ListOfVoices_VoicesPerFlavor.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfVoices,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* repeated speaker.beta2.ListOfVoices.VoicesPerFlavor flavors = 1; */
    for (let i = 0; i < message.flavors.length; i++)
      ListOfVoices_VoicesPerFlavor.internalBinaryWrite(
        message.flavors[i],
        writer.tag(1, WireType.LengthDelimited).fork(),
        options
      ).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfVoices
 */
export const ListOfVoices = new ListOfVoices$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfVoices_MultilingualText$Type extends MessageType<ListOfVoices_MultilingualText> {
  constructor() {
    super("speaker.beta2.ListOfVoices.MultilingualText", [
      { no: 1, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
    ]);
  }
  create(
    value?: PartialMessage<ListOfVoices_MultilingualText>
  ): ListOfVoices_MultilingualText {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.language = "";
    message.text = "";
    if (value !== undefined)
      reflectionMergePartial<ListOfVoices_MultilingualText>(
        this,
        message,
        value
      );
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfVoices_MultilingualText
  ): ListOfVoices_MultilingualText {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string language */ 1:
          message.language = reader.string();
          break;
        case /* string text */ 2:
          message.text = reader.string();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfVoices_MultilingualText,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string language = 1; */
    if (message.language !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.language);
    /* string text = 2; */
    if (message.text !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.text);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfVoices.MultilingualText
 */
export const ListOfVoices_MultilingualText =
  new ListOfVoices_MultilingualText$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfVoices_Voice$Type extends MessageType<ListOfVoices_Voice> {
  constructor() {
    super("speaker.beta2.ListOfVoices.Voice", [
      { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 2, name: "gender", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      {
        no: 3,
        name: "native_language",
        kind: "scalar",
        T: 9 /*ScalarType.STRING*/,
      },
      { no: 4, name: "accent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 5, name: "origin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 6, name: "age", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 7, name: "emotion", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      { no: 8, name: "style", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      {
        no: 9,
        name: "preview_prompt",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfVoices_MultilingualText,
      },
      {
        no: 10,
        name: "free_text",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfVoices_MultilingualText,
      },
    ]);
  }
  create(value?: PartialMessage<ListOfVoices_Voice>): ListOfVoices_Voice {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.name = "";
    message.gender = "";
    message.nativeLanguage = "";
    message.accent = "";
    message.origin = "";
    message.age = "";
    message.emotion = "";
    message.style = "";
    message.previewPrompt = [];
    message.freeText = [];
    if (value !== undefined)
      reflectionMergePartial<ListOfVoices_Voice>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfVoices_Voice
  ): ListOfVoices_Voice {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string name */ 1:
          message.name = reader.string();
          break;
        case /* string gender */ 2:
          message.gender = reader.string();
          break;
        case /* string native_language */ 3:
          message.nativeLanguage = reader.string();
          break;
        case /* string accent */ 4:
          message.accent = reader.string();
          break;
        case /* string origin */ 5:
          message.origin = reader.string();
          break;
        case /* string age */ 6:
          message.age = reader.string();
          break;
        case /* string emotion */ 7:
          message.emotion = reader.string();
          break;
        case /* string style */ 8:
          message.style = reader.string();
          break;
        case /* repeated speaker.beta2.ListOfVoices.MultilingualText preview_prompt */ 9:
          message.previewPrompt.push(
            ListOfVoices_MultilingualText.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        case /* repeated speaker.beta2.ListOfVoices.MultilingualText free_text */ 10:
          message.freeText.push(
            ListOfVoices_MultilingualText.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfVoices_Voice,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string name = 1; */
    if (message.name !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.name);
    /* string gender = 2; */
    if (message.gender !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.gender);
    /* string native_language = 3; */
    if (message.nativeLanguage !== "")
      writer.tag(3, WireType.LengthDelimited).string(message.nativeLanguage);
    /* string accent = 4; */
    if (message.accent !== "")
      writer.tag(4, WireType.LengthDelimited).string(message.accent);
    /* string origin = 5; */
    if (message.origin !== "")
      writer.tag(5, WireType.LengthDelimited).string(message.origin);
    /* string age = 6; */
    if (message.age !== "")
      writer.tag(6, WireType.LengthDelimited).string(message.age);
    /* string emotion = 7; */
    if (message.emotion !== "")
      writer.tag(7, WireType.LengthDelimited).string(message.emotion);
    /* string style = 8; */
    if (message.style !== "")
      writer.tag(8, WireType.LengthDelimited).string(message.style);
    /* repeated speaker.beta2.ListOfVoices.MultilingualText preview_prompt = 9; */
    for (let i = 0; i < message.previewPrompt.length; i++)
      ListOfVoices_MultilingualText.internalBinaryWrite(
        message.previewPrompt[i],
        writer.tag(9, WireType.LengthDelimited).fork(),
        options
      ).join();
    /* repeated speaker.beta2.ListOfVoices.MultilingualText free_text = 10; */
    for (let i = 0; i < message.freeText.length; i++)
      ListOfVoices_MultilingualText.internalBinaryWrite(
        message.freeText[i],
        writer.tag(10, WireType.LengthDelimited).fork(),
        options
      ).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfVoices.Voice
 */
export const ListOfVoices_Voice = new ListOfVoices_Voice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOfVoices_VoicesPerFlavor$Type extends MessageType<ListOfVoices_VoicesPerFlavor> {
  constructor() {
    super("speaker.beta2.ListOfVoices.VoicesPerFlavor", [
      { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
      {
        no: 2,
        name: "description",
        kind: "scalar",
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 3,
        name: "voices",
        kind: "message",
        repeat: 1 /*RepeatType.PACKED*/,
        T: () => ListOfVoices_Voice,
      },
    ]);
  }
  create(
    value?: PartialMessage<ListOfVoices_VoicesPerFlavor>
  ): ListOfVoices_VoicesPerFlavor {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.name = "";
    message.description = "";
    message.voices = [];
    if (value !== undefined)
      reflectionMergePartial<ListOfVoices_VoicesPerFlavor>(
        this,
        message,
        value
      );
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: ListOfVoices_VoicesPerFlavor
  ): ListOfVoices_VoicesPerFlavor {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* string name */ 1:
          message.name = reader.string();
          break;
        case /* string description */ 2:
          message.description = reader.string();
          break;
        case /* repeated speaker.beta2.ListOfVoices.Voice voices */ 3:
          message.voices.push(
            ListOfVoices_Voice.internalBinaryRead(
              reader,
              reader.uint32(),
              options
            )
          );
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: ListOfVoices_VoicesPerFlavor,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* string name = 1; */
    if (message.name !== "")
      writer.tag(1, WireType.LengthDelimited).string(message.name);
    /* string description = 2; */
    if (message.description !== "")
      writer.tag(2, WireType.LengthDelimited).string(message.description);
    /* repeated speaker.beta2.ListOfVoices.Voice voices = 3; */
    for (let i = 0; i < message.voices.length; i++)
      ListOfVoices_Voice.internalBinaryWrite(
        message.voices[i],
        writer.tag(3, WireType.LengthDelimited).fork(),
        options
      ).join();
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.ListOfVoices.VoicesPerFlavor
 */
export const ListOfVoices_VoicesPerFlavor =
  new ListOfVoices_VoicesPerFlavor$Type();
